const PaymentRow = ({ item, paymentMethods, amount, ItemCurrency }) => {
  return (
    <tr>
      <td>{item}</td>
      <td>
        <span className={`payment-method ${paymentMethods?.[0]?.provider?.toLowerCase()}`}>
          {paymentMethods?.[0]?.provider}
        </span>
      </td>
      <td>
        <div className="amount-cell">
          <span className="amount">{amount?.toLocaleString()}</span>
          {ItemCurrency?.[0]?.currency && (
            <span className="currency">
              {ItemCurrency?.[0]?.currency}
            </span>
          )}
        </div>
      </td>
      {/* <td>{paymentOption}</td> */}
    </tr>
  );
};

export default PaymentRow;
